(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-pro-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('gh-pro-product-v1')) return;
    customElements.define('gh-pro-product-v1', class extends HTMLElement {
      connectedCallback() {
        if (this.ghProReady) return;
        const dataNode = this.querySelector('[data-variant-data]');
        if (!dataNode) {
          if (!this.ghProWaiting) {
            this.ghProWaiting = new MutationObserver(() => {
              if (this.querySelector('[data-variant-data]')) this.connectedCallback();
            });
            this.ghProWaiting.observe(this, { childList: true, subtree: true, characterData: true });
          }
          return;
        }
        try { this.variants = JSON.parse(dataNode.textContent); } catch (_) { return; }
        if (this.ghProWaiting) {
          this.ghProWaiting.disconnect();
          this.ghProWaiting = null;
        }
        this.ghProReady = true;
        this.requiresPlan = this.dataset.requiresPlan === 'true';
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-variant-radio]')) this.selectVariant(event.target.value, true);
        });
        this.addEventListener('click', (event) => {
          const thumbnail = event.target.closest('[data-media-target]');
          if (!thumbnail || !this.contains(thumbnail) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.selectMedia(thumbnail.dataset.mediaTarget);
        });
        const checked = this.querySelector('[data-variant-radio]:checked, [data-default-variant]');
        if (checked) this.selectVariant(checked.value, false);
      }
      disconnectedCallback() {
        if (this.ghProWaiting) {
          this.ghProWaiting.disconnect();
          this.ghProWaiting = null;
        }
      }
      selectMedia(mediaId) {
        if (!mediaId || !Array.from(this.querySelectorAll('[data-media-id]')).some(item => item.dataset.mediaId === String(mediaId))) return;
        this.querySelectorAll('[data-media-id]').forEach((item) => {
          item.hidden = item.dataset.mediaId !== String(mediaId);
          if (item.hidden) {
            item.querySelectorAll('video').forEach((video) => video.pause());
            item.querySelectorAll('iframe').forEach((frame) => {
              /* Only reset an actively displayed iframe to stop external playback. */
              if (item.dataset.wasVisible === 'true') frame.src = frame.src;
            });
          }
          item.dataset.wasVisible = String(!item.hidden);
        });
        this.querySelectorAll('[data-media-target]').forEach((thumb) => {
          if (thumb.dataset.mediaTarget === String(mediaId)) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
      }
      selectVariant(id, updateUrl) {
        const variant = this.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        this.querySelector('[data-product-price]').textContent = variant.price;
        const comparePrice = this.querySelector('[data-compare-price]');
        comparePrice.textContent = variant.comparePrice;
        comparePrice.hidden = !variant.comparePrice;
        const unitPrice = this.querySelector('[data-unit-price]');
        unitPrice.textContent = variant.unitPrice;
        unitPrice.hidden = !variant.unitPrice;
        const buyButton = this.querySelector('[data-add-to-cart]');
        const requiresPlan = this.requiresPlan || variant.requiresPlan;
        buyButton.disabled = !variant.available || requiresPlan;
        buyButton.textContent = requiresPlan ? '購入方法についてお問い合わせください' : variant.available ? 'カートに追加する' : '売り切れ';
        this.querySelector('[data-product-status]').textContent = requiresPlan
          ? 'この商品は購入プランの選択が必要です。お問い合わせください。'
          : variant.available
            ? '選択中の商品は購入できます。'
            : this.variants.some(item => item.available)
              ? '選択中の仕様は売り切れです。ほかの仕様をお選びください。'
              : '現在、すべての仕様が売り切れです。';
        const quantity = this.querySelector('[data-quantity]');
        const minimum = Math.max(1, Number(variant.min) || 1);
        const increment = Math.max(1, Number(variant.increment) || 1);
        const maximum = variant.max == null ? null : Number(variant.max);
        quantity.min = String(minimum);
        quantity.step = String(increment);
        if (maximum !== null) quantity.max = String(maximum);
        else quantity.removeAttribute('max');
        let nextQuantity = Math.max(minimum, Number(quantity.value) || minimum);
        nextQuantity = minimum + Math.ceil((nextQuantity - minimum) / increment) * increment;
        if (maximum !== null && nextQuantity > maximum) nextQuantity = minimum + Math.floor((maximum - minimum) / increment) * increment;
        quantity.value = String(Math.max(minimum, nextQuantity));
        const rules = [];
        if (minimum > 1) rules.push(`最小 ${minimum} 点。`);
        if (increment > 1) rules.push(`${increment} 点単位。`);
        if (maximum !== null) rules.push(`最大 ${maximum} 点。`);
        this.querySelector('[data-quantity-rules]').textContent = rules.join(' ');
        this.selectMedia(variant.mediaId || this.dataset.initialMedia);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          try { window.history.replaceState(window.history.state, '', url); } catch (_) { /* Theme previews can restrict URL updates. */ }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
